import type { TOC } from '@ember/component/template-only'
import type DeleteStudentsRoute from 'teacher-ui-client/manage/rollover/steps/delete-students/route'
import { LinkTo } from '@ember/routing'
import { t } from 'ember-intl'
import { hash } from '@ember/helper'
import { UiButtonLinkTo } from 'teacher-ui-client/components/ui-button/link-to'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<DeleteStudentsRoute>
  }
}
export const ManageRolloverStepsDeleteStudentsPage: TOC<Signature> = <template>
  <div class="mx-auto max-w-3xl px-2">
    <div class="mb-12">
      <h3 class="text-dusty-black-250 mt-8 mb-6">
        {{t "manage.rollover.steps.delete_students.stepContentHeader"}}
      </h3>
      <div class="space-y-6 text-xl">
        <p>
          {{t "manage.rollover.steps.delete_students.removeStudents1"}}
          <strong><LinkTo @route="manage.students" @query={{hash allocation="UNALLOCATED"}}>{{t
                "manage.title.students"
              }}</LinkTo></strong>
          {{t "manage.rollover.steps.delete_students.removeStudents2"}}
        </p>
        <p>
          <strong>{{t "manage.rollover.steps.delete_students.note"}}:</strong>
          {{t "manage.rollover.steps.delete_students.cannotDelete"}}
        </p>
        <p>
          {{t "manage.rollover.steps.delete_students.canSkipStep"}}
        </p>
      </div>
    </div>
    <div class="text-right">
      <UiButtonLinkTo
        @appearance={{ButtonAppearance.regular}}
        @route="manage.students"
        @query={{hash allocation="UNALLOCATED"}}
      >{{t "manage.rollover.goToSection" section=(t "manage.title.students")}}</UiButtonLinkTo>
    </div>
  </div>
</template>

export default RouteTemplate(ManageRolloverStepsDeleteStudentsPage)
